import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";
import logo from "./logo.png";
import axios from "axios";
import { User, Lock, LogIn, X, Eye, EyeOff } from "lucide-react";


function App() {
  console.log("🧠 Login.jsx carregou");
  const [apiPronta, setApiPronta] = useState(false);
  const [usuario, setUsuario] = useState("");
  const [senha, setSenha] = useState("");
  const [lembrar, setLembrar] = useState(false);
  const [erro, setErro] = useState("");
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const navigate = useNavigate();
  const senhaRef = useRef(null);
  const emailRef = useRef(null);

  useEffect(() => {
    const emailSalvo = localStorage.getItem("emailSalvo");
    const senhaSalva = localStorage.getItem("senhaSalva");
    if (emailSalvo) {
      setUsuario(emailSalvo);
      setLembrar(true);
    }
    if (senhaSalva) {
      setSenha(senhaSalva);
    }
    emailRef.current?.focus();
  }, []);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API}/ping`)
      .then(() => setApiPronta(true))
      .catch(() => {
        setApiPronta(false);
        console.warn("API não respondeu ao ping.");
      });
  }, []);


  const handleLogin = async () => {
    console.log("👉 handleLogin foi chamado");
    if (!usuario || !senha) {
      setErro("Preencha todos os campos.");
      return;
    }

    try {
      console.log("🔄 Enviando requisição para login...");
      console.log("🌐 URL da API:", process.env.REACT_APP_API);
      const response = await axios.post(`${process.env.REACT_APP_API}/login`, {

        email: usuario,
        senha: senha
      });

      if (response.data.sucesso) {
        setErro("");

        if (lembrar) {
          localStorage.setItem("emailSalvo", usuario);
          localStorage.setItem("senhaSalva", senha);
        } else {
          localStorage.removeItem("emailSalvo");
          localStorage.removeItem("senhaSalva");
        }

        const loginBruto = response.data.usuario.login.toLowerCase();
        const nomeFormatado = loginBruto
          .split(" ")
          .map(p => p.charAt(0).toUpperCase() + p.slice(1))
          .join(" ");

        localStorage.setItem("nomeUsuario", nomeFormatado);

        // ✅ SALVAR O TOKEN JWT AQUI
        sessionStorage.setItem("token", response.data.token);

        navigate("/menu", { state: { nome: nomeFormatado } });
      } else {
        setErro("Login ou senha incorretos!");
      }
} catch (error) {
  console.log("❌ Erro na requisição de login:", error);

  if (error.response) {
    if (error.response.status === 401) {
      setErro("Usuário ou senha incorretos!");
    } else {
      setErro("Erro ao conectar com o servidor.");
    }
  } else {
    setErro("Erro ao conectar com o servidor.");
  }
}  // <-- fecha só o catch
};   // <-- fecha a função handleLogin

  const handleInputChange = (setter) => (e) => {
    setter(e.target.value);
    if (usuario && senha) setErro("");
  };

  const renderInput = (label, value, onChange, placeholder, Icon, type = "text", clearField, inputRef, onKeyDown) => {
    const isPassword = type === "password";
    return (
      <div className={`input-container ${value ? "has-value" : ""}`}>
        <label className="floating-label">{label}</label>
        <div
          className={`input-group ${value ? "focused" : ""}`}
          onFocus={(e) => e.currentTarget.classList.add("focused")}
          onBlur={(e) => e.currentTarget.classList.remove("focused")}
          tabIndex={-1}
          style={{ position: "relative", width: "100%" }}
        >
          <Icon size={20} color="#006837" className="input-icon-inside" />
          <input
            type={isPassword && !mostrarSenha ? "password" : "text"}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            onKeyDown={onKeyDown}
            ref={inputRef}
            className="input-field-unified"
            style={{ outline: "none", border: "none", flex: 1, paddingRight: "60px" }}
          />
          {isPassword && value && (
            <div
              style={{ position: "absolute", right: 36, top: "50%", transform: "translateY(-50%)", cursor: "pointer" }}
              onClick={() => setMostrarSenha((prev) => !prev)}
            >
              {mostrarSenha ? <EyeOff size={16} color="#666" /> : <Eye size={16} color="#666" />}
            </div>
          )}
          {value && (
            <X
              size={16}
              color="#666"
              onClick={clearField}
              style={{
                position: "absolute",
                right: 12,
                top: "50%",
                transform: "translateY(-50%)",
                cursor: "pointer",
                background: "transparent",
                padding: 0,
                zIndex: 1,
              }}
              aria-label="Limpar"
            />
          )}
        </div>
      </div>
    );
  };

  return (
    <div
      className="outer-wrapper"
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
        minHeight: "100vh",
        padding: "2rem 1rem"
      }}

    >
      <div className="login-container">
        <img src={logo} alt="Logo Benassi" className="logo" />
        <div className="login-card">
          {renderInput(
            "E-mail",
            usuario,
            handleInputChange(setUsuario),
            "Digite seu e-mail",
            User,
            "text",
            () => setUsuario(""),
            emailRef,
            (e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                senhaRef.current?.focus();
              }
            }
          )}
          {renderInput(
            "Senha",
            senha,
            handleInputChange(setSenha),
            "Digite sua senha",
            Lock,
            "password",
            () => setSenha(""),
            senhaRef,
            (e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleLogin();
              }
            }
          )}

          <div
            className="checkbox-container"
            style={{ fontSize: "0.75rem", display: "flex", alignItems: "center", gap: "6px", marginBottom: "1rem" }}
          >
            <input
              type="checkbox"
              checked={lembrar}
              onChange={(e) => setLembrar(e.target.checked)}
              style={{ margin: 0 }}
            />
            <label style={{ margin: 0 }}>Lembrar-me</label>
          </div>

          <div style={{ display: "flex", justifyContent: "center" }}>
            <button
              onClick={handleLogin}
              disabled={!apiPronta}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "200px",
                padding: "10px 16px",
                opacity: apiPronta ? 1 : 0.5,
                cursor: apiPronta ? "pointer" : "not-allowed"
              }}
            >
              <span style={{ textAlign: "left" }}>
                {apiPronta ? "Entrar" : "Conectando..."}
              </span>
              <LogIn size={18} />
            </button>

          </div>
          {erro && <div className="error">{erro}</div>}
        </div>
        <div className="footer">Por Luciana Figueredo</div>
      </div>
    </div>
  );
}

export default App;
